import type { GroupWithFirms, GroupWithLogo } from '../../types/Groupement'

export async function fetchGroupsList({
  strapiUrl,
  token,
}: {
  strapiUrl: string
  token: string
}): Promise<{ list: GroupWithFirms[] | null; count: number | null }> {
  if (strapiUrl && token) {
    const url = `${strapiUrl}/api/accounting-group-custom`

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    const responseData = await response.json()

    const list: GroupWithFirms[] = responseData || []

    return {
      count: list.length,
      list,
    }
  }

  return {
    count: null,
    list: null,
  }
}

export async function fetchGroup({
  strapiUrl,
  token,
  slug,
}: {
  strapiUrl: string
  token: string
  slug: string
}): Promise<GroupWithFirms | null> {
  if (strapiUrl && token) {
    const url = `${strapiUrl}/api/accounting-group-custom/${slug}`

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      return null
    }

    const [responseData] = await response.json()

    return responseData || null
  }

  return null
}

export async function fetchGroupByFirmId({
  strapiUrl,
  token,
  firmId,
}: {
  strapiUrl: string
  token: string
  firmId: number
}): Promise<{ list: GroupWithLogo[] | null; count: number | null }> {
  if (strapiUrl && token) {
    const url = `${strapiUrl}/api/accounting-group-custom/byFirmId/${firmId}`

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    const responseData = await response.json()

    const list: GroupWithLogo[] = responseData || []

    return {
      count: list.length,
      list,
    }
  }

  return {
    count: null,
    list: null,
  }
}
